import { useContext } from 'react';
import { SelectOptionsContext } from '../context/SelectOptionsContext';

export const useIsBottomSheetGiftMode = () => {
  const context = useContext(SelectOptionsContext);
  return context.mode === 'gift';
};
